module.exports = __webpack_public_path__ + "static/media/FAQs icon (active).989299ed.svg";